/**
 * The two glyphs the minimap draws for marks that are not dots (P1.9-T179): a star for a quest target and a skull for an
 * elite or a boss, each 7 by 7 whole pixels, a `#` for a pixel drawn. They are the pixels of the original art in
 * `odyssey-client/src/ui/art/marks/glyph/star_8.grid` and `skull_8.grid` (the top left 7 by 7 of each 8 by 8 grid),
 * which a test holds equal, so the canvas painter and the kit's atlas draw one shape.
 */

/**
 * The side of a glyph in pixels.
 */
export const MINIMAP_GLYPH_SIZE = 7;

/**
 * The glyphs' pixels by shape, rows top to bottom.
 */
export const MINIMAP_GLYPHS = {
  star: ["...#...", "...#...", "#######", ".#####.", "..###..", ".##.##.", ".#...#."],
  skull: [".#####.", "#######", "#.###.#", "#.###.#", ".#####.", "..#.#..", "..###.."],
} as const satisfies Readonly<Record<string, readonly string[]>>;
